import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'

import { selectors as NotificationsSelectors } from 'data/notifications'

import ExitButton from '../ExitButton'

class MainHeader extends Component {
  static propTypes = {
    showArchivedThreads: PropTypes.bool.isRequired,
    setShowArchivedThreads: PropTypes.func.isRequired,
  }

  toggleArchivedThreads = () => {
    this.props.setShowArchivedThreads(!this.props.showArchivedThreads)
  }

  renderBadge = () => {
    const { showArchivedThreads, closedThreadsActive } = this.props
    return (
      !showArchivedThreads &&
      closedThreadsActive && (
        <div
          className="background-red radius-round margin-left-small"
          style={{
            width: 6,
            height: 6,
          }}
        />
      )
    )
  }
  renderShowResolved = () => {
    const { showArchivedThreads } = this.props
    return (
      <div
        className="flexbox flexbox-align-center margin-left-auto margin-right-medium pointer"
        onClick={this.toggleArchivedThreads}
      >
        <div className="font-weight-medium shade-20 shade-10-on-hover font-size-large">
          {showArchivedThreads ? 'Hide resolved' : 'Show resolved'}
        </div>
        {this.renderBadge()}
      </div>
    )
  }

  render() {
    return (
      <div className="padding-horizontal-large flexbox-no-shrink">
        <div
          className={classNames(
            'flexbox flexbox-align-center',
            'width-full',
            'border-bottom-medium',
            this.props.scrolling ? 'border-shade-50' : 'border-transparent'
          )}
          style={{ height: 60 }}
        >
          <div className="font-size-large bold" style={{ fontSize: 16 }}>
            All threads
          </div>

          {this.renderShowResolved()}
          <ExitButton />
        </div>
      </div>
    )
  }
}

export default connect(state => {
  return NotificationsSelectors.getCurrentNoteThreadsNotificationsActivity(
    state
  )
})(MainHeader)
